import { telephone } from "@simplybusiness/icons";
import { Icon, Link, Text } from "@simplybusiness/mobius";
import { useSnowplowContext } from "@simplybusiness/services";
import { CardModal } from "../InfoModal/CardModal";

type PriceDetailsProps = {
  priceDetails: {
    phoneNumber: {
      displayText: string;
      number: string;
      formatted: string;
    };
    displayText: string[];
  };
};

export const PriceDetails = ({ priceDetails }: PriceDetailsProps) => {
  const { snowplow } = useSnowplowContext();
  const { displayText, phoneNumber } = priceDetails;

  const modalText = (
    <>
      {displayText.map((line: string) => (
        <Text key={line}>{line}</Text>
      ))}
      <Text>
        <strong>{phoneNumber.displayText}</strong>
      </Text>
      <Text>
        <Link
          className="mobius-quote-card__price-details-phone"
          href={`tel:${phoneNumber.number}`}
        >
          <Icon
            icon={telephone}
            className="mobius-quote-card__price-details-icon"
          />
          {phoneNumber.formatted}
        </Link>
      </Text>
    </>
  );

  return (
    <div className="mobius-quote-card__price-details">
      <CardModal
        onOpen={() => snowplow?.trigger("priceDetailsPopUpOpened")}
        toggleText="Price Details"
        title="Price Details"
        body={modalText}
        toggleIcon={false}
      />
    </div>
  );
};
